import React from "react";
import { Layer, Source } from "react-map-gl";
import { vectorSource } from "./helpers.layers";

export default function MapAndSourceIDLayer({ layer, getBeforeIdLayerId, hoverInfo, layerColor }) {
  const { mapboxId, sourceId, layerId, sourceLayer, renderLayer, opacity } = layer;

  return (
    <Source {...vectorSource(mapboxId, sourceId)}>
      <Layer
        id={layerId}
        source-layer={sourceLayer}
        beforeId={getBeforeIdLayerId()}
        type="fill"
        layout={{
          visibility: renderLayer ? "visible" : "none",
        }}
        paint={{
          "fill-color": layerColor || "transparent",
          "fill-opacity": opacity / 100,
        }}
      />
      {hoverInfo && (
        <Layer
          id={`${layerId}-highlighted`}
          source-layer={sourceLayer}
          // beforeId={getBeforeIdLayerId()}
          type="line"
          layout={{
            visibility: renderLayer ? "visible" : "none",
          }}
          filter={["==", ["get", "region_id"], hoverInfo]}
          paint={{
            "line-color": "#ffffff",
            // "line-color": "red",
            "line-width": 3,
          }}
        />
      )}
    </Source>
  );
}
